// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-list-group .task-list-group__items{padding:1rem}.task-list-group .v-list-group__header__append-icon{min-width:unset!important;margin-left:8px!important}", ""]);
// Exports
module.exports = exports;
